import { render, staticRenderFns } from "./Welcome_ad.vue?vue&type=template&id=9611793c&scoped=true"
import script from "./Welcome_ad.vue?vue&type=script&lang=js"
export * from "./Welcome_ad.vue?vue&type=script&lang=js"
import style0 from "./Welcome_ad.vue?vue&type=style&index=0&id=9611793c&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9611793c",
  null
  
)

export default component.exports